import * as React from 'react'
import { CheckboxProps } from '../Checkbox/types'
import Checkbox from '../Checkbox'
import AccordionItem from '../Accordion/AccordionItem'
import './style.scss'

interface CheckboxWithAccordionItemProps extends CheckboxProps {
  labelFirstLine: string
  labelRestLines: string
}

const CheckboxWithAccordionItem: React.FC<CheckboxWithAccordionItemProps> = ({
  field,
  labelFirstLine,
  labelRestLines,
  required,
  onChange,
  className,
  revalidate
}) => {

  return (
    <div className={`CheckboxWithAccordionItem ${className || ''}`}>
      <Checkbox
        field={field}
        required={required}
        onChange={onChange}
        revalidate={revalidate}
      >
        <AccordionItem 
          className="FontS bg-white"
          title={labelFirstLine}
          content={labelRestLines}
        />
      </Checkbox>
    </div>
  )
}

export default CheckboxWithAccordionItem
